import { map } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { AppState } from '../_reducers';
import { LandRegistry } from '../_models';
import { environment } from '../../../environments/environment';
import { selectAllLandRegistries } from '../_selectors/landRegistry.selectors';

@Injectable()
export class LandRegistryService {
  private apiBaseUrl = environment.apiBaseUrl;
  private landRegistryList: Observable<LandRegistry[]>;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>
  ) {
    this.landRegistryList = this.store.pipe(select(selectAllLandRegistries));
  }

  getFromLocalStore(): Observable<LandRegistry[]> {
    return this.landRegistryList;
  }

  getLandRegistries(): Observable<LandRegistry[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/landRegistries')
      .pipe(map((response) => response));
  }

  getLandRegistry(id: number): Observable<LandRegistry> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/landRegistries/' + id)
      .pipe(map((response) => response));
  }

  saveLandRegistry(landRegistry): Observable<LandRegistry> {
    // Create a shallow copy of the landRegistry object
    const mutableLandRegistry = { ...landRegistry };

    // delete mutableLandRegistry.area;
    delete mutableLandRegistry.lastUpdated;
    delete mutableLandRegistry.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    mutableLandRegistry.companyId = companySelected ? companySelected.id : null;

    if (mutableLandRegistry.id) {
      return this.http
        .put<LandRegistry>(
          this.apiBaseUrl + 'api/private/v1/landRegistries/' + mutableLandRegistry.id,
          mutableLandRegistry
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<LandRegistry>(this.apiBaseUrl + 'api/private/v1/landRegistries/', mutableLandRegistry)
        .pipe(map((response) => response));
    }
  }

  deleteLandRegistry(id: number): Observable<LandRegistry> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/landRegistries/' + id).pipe(
      map((response) => {
        return { id } as LandRegistry;
      })
    );
  }

  getUseTypeLandRegistryListList(selectedPac) {
    if (selectedPac == 'ITA') {
      return _.orderBy(
        [
          { key: 'Modulo 26', value: 'Modulo 26' },
          { key: 'Seminativo', value: 'Seminativo' },
          { key: 'Seminativo irriguo', value: 'Seminativo irriguo' },
          { key: 'Seminativo arborato', value: 'Seminativo arborato' },
          { key: 'Seminativo arborato irriguo', value: 'Seminativo arborato irriguo' },
          { key: 'Prato', value: 'Prato' },
          { key: 'Prato irriguo', value: 'Prato irriguo' },
          { key: 'Prato arborato', value: 'Prato arborato' },
          { key: 'Prato irriguo arborato', value: 'Prato irriguo arborato' },
          { key: 'Prato a marcita', value: 'Prato a marcita' },
          { key: 'Risaia stabile', value: 'Risaia stabile' },
          { key: 'Pascolo', value: 'Pascolo' },
          { key: 'Pascolo arborato', value: 'Pascolo arborato' },
          { key: 'Pascolo cespuglio', value: 'Pascolo cespuglio' },
          { key: 'Giardino', value: 'Giardino' },
          { key: 'Orto', value: 'Orto' },
          { key: 'Orto irriguo', value: 'Orto irriguo' },
          { key: 'Agrumeto', value: 'Agrumeto' },
          { key: 'Vigneto', value: 'Vigneto' },
          { key: 'Frutteto', value: 'Frutteto' },
          { key: 'Oliveto', value: 'Oliveto' },
          { key: 'Gelseto', value: 'Gelseto' },
          {
            key: 'Colture speciali ad alcune parti d’Italia',
            value: 'Colture speciali ad alcune parti d’Italia',
          },
          { key: 'Castagneto da frutteto', value: 'Castagneto da frutteto' },
          { key: 'Canneto', value: 'Canneto' },
          { key: 'Bosco ad alto fusto', value: 'Bosco ad alto fusto' },
          { key: 'Bosco ceduo', value: 'Bosco ceduo' },
          { key: 'Bosco misto', value: 'Bosco misto' },
          { key: 'Incolto produttivo', value: 'Incolto produttivo' },
          {
            key: 'Ferrovia e tranvia con sede propria',
            value: 'Ferrovia e tranvia con sede propria',
          },
          { key: 'Incolto sterile', value: 'Incolto sterile' },
        ],
        'value'
      );
    } else if (selectedPac == 'ESP') {
      return _.orderBy(
        [
          { key: 'AG', value: 'AG - Corrientes y superficies de agua' },
          { key: 'CA', value: 'CA - Viales' },
          { key: 'CF', value: 'CF - Asociacion cítricos - frutales' },
          { key: 'CI', value: 'CI - Cítricos' },
          { key: 'CS', value: 'CS - Asociacion cítricos - frutales de cascara' },
          { key: 'CV', value: 'CV - Asociacion cítricos - viñedo' },
          { key: 'ED', value: 'ED - Edificaciones' },
          { key: 'EP', value: 'EP - Elemento del paisaje' },
          { key: 'FF', value: 'FF - Asociacion frutales - frutales de cascara' },
          { key: 'FL', value: 'FL - Frutos secos y olivar' },
          { key: 'FO', value: 'FO - Forestal' },
          { key: 'FS', value: 'FS - Frutos secos' },
          { key: 'FV', value: 'FV - Frutos secos y viñedo' },
          { key: 'FY', value: 'FY - Frutales' },
          { key: 'IM', value: 'IM - Improductivos' },
          { key: 'IV', value: 'IV - Invernaderos y cultivos bajo plastico' },
          { key: 'OC', value: 'OC - Asociacion olivar - cítricos' },
          { key: 'OF', value: 'OF - Olivar frutal' },
          { key: 'OV', value: 'OV - Olivar' },
          { key: 'PA', value: 'PA - Pasto arbustivo' },
          { key: 'PS', value: 'PS - Pastizal' },
          { key: 'TA', value: 'TA - Tierra campa / Tierras arables' },
          { key: 'TH', value: 'TH - Huerta' },
          { key: 'VF', value: 'VF - Viñedo - frutal' },
          { key: 'VI', value: 'VI - Viñedo' },
          { key: 'VO', value: 'VO - Viñedo - olivar' },
          { key: 'ZC', value: 'ZC - Zona concentracion parcelaria' },
          { key: 'ZU', value: 'ZU - Zona Urbana' },
          { key: 'ZV', value: 'ZV - Zona censurada' },
        ],
        'value'
      );
    } else {
      return [];
    }
  }
}
